import styled, { css } from 'styled-components'

export const Wrapper = styled.div.attrs({
  className: 'photo-wrapper',
})`
  position: relative;
  width: 100%;
  max-width: ${(props) => props.maxWidth};
`

export const Photo = styled.figure.attrs({
  className: 'photo-wrapper__photo',
})`
  ${({ theme, proportion, url, urlMobile, backgroundSize }) => {
    const photoConfig = theme.components.photo || {}

    return css`
      ${proportion === '1:1' && 'padding-top: 100%;'}
      ${proportion === '4:3' && 'padding-top: 75%;'}
      ${proportion === '16:9' && 'padding-top: 56.25%;'}

      background-image: url(${url});
      background-position: center center;
      background-repeat: no-repeat;
      background-size: ${backgroundSize};

      border-radius: ${photoConfig.rounded
        ? photoConfig.borderRadius || '0px'
        : '0'};

      overflow: hidden;

      @media (max-width: 768px) {
        ${urlMobile &&
        css`
          background-image: url(${urlMobile});
        `}
      }
    `
  }}
`
